"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global = window;
var YoutubeInject = /** @class */ (function () {
    function YoutubeInject(videoId, wrapperId, autoInit) {
        if (autoInit === void 0) { autoInit = true; }
        /***********************
         *
         * please make sure that page has script:
         * <script type="text/javascript" src="https://www.youtube.com/iframe_api"></script>
         * Use with: window.onYouTubeIframeAPIReady = function () { }
         ***********************/
        this.tag = document.createElement('script');
        this.videoId = videoId;
        this.wrapperId = wrapperId;
        this.activePlayers = window.ytActivePlayers;
        if (autoInit) {
            this.initPlayer();
        }
    }
    YoutubeInject.prototype.initPlayer = function (autoplay) {
        if (autoplay === void 0) { autoplay = true; }
        this.player = new YT.Player(this.wrapperId, {
            height: '100%',
            width: '100%',
            playerVars: {
                loop: 0,
                controls: 1,
                showinfo: 0,
                autohide: 1,
                modestbranding: 1,
                start: 2,
                rel: 0,
                autoplay: autoplay ? 1 : 0
            },
            videoId: this.videoId,
            events: {
                'onReady': YoutubeInject.onPlayerReady,
                'onStateChange': this.onPlayerStateChange
            }
        });
        this.activePlayers.push(this.player);
    };
    YoutubeInject.onPlayerReady = function (event) {
        event.target.playVideo();
    };
    YoutubeInject.prototype.onPlayerStateChange = function (event) {
        if (event && event.data === 1) {
            window.ytActivePlayers.forEach(function (player) {
                if (player !== event.target) {
                    player.stopVideo();
                }
            });
        }
    };
    YoutubeInject.prototype.stopVideo = function () {
        this.player.stopVideo();
    };
    YoutubeInject.prototype.startVideo = function () {
        this.player.playVideo();
    };
    return YoutubeInject;
}());
exports.default = YoutubeInject;
global.YoutubeInject = YoutubeInject;
global.ytActivePlayers = [];
